import Teachers from './Teachers.page';

export default Teachers;